module.exports = __webpack_public_path__ + "img/cdkf1.6c458541.jpg";